const COMMON_URL = `${process.env.REACT_APP_COMMON_SERVICE_ORIGIN_URL}/account-setup`

const UserShipperRequestTypeApiUrls = {
  GET: `${COMMON_URL}/user-for-shipper-request/user-shipper-request-type/get`,
  POST: `${COMMON_URL}/user-for-shipper-request/user-shipper-request-type/create`,
  PUT: `${COMMON_URL}/user-for-shipper-request/user-shipper-request-type/update`,
  DELETE: `${COMMON_URL}/user-for-shipper-request/user-shipper-request-type/delete`,
  EXPORT: `${COMMON_URL}/user-for-shipper-request/user-shipper-request-type/download`
}

export default UserShipperRequestTypeApiUrls
